<mat-icon *ngIf="!disabled && type === 'currency'" class="text-icon">
    <pep-icon name="number_coins">
    </pep-icon>
</mat-icon>
<mat-icon *ngIf="!disabled && type === 'percentage'" class="text-icon">
    <pep-icon name="number_percent">
    </pep-icon>
</mat-icon>
<mat-icon *ngIf="!disabled && type === 'int'" class="text-icon">
    <pep-icon name="number_number">
    </pep-icon>
</mat-icon>
<mat-icon *ngIf="!disabled && type === 'real'" class="text-icon">
    <pep-icon name="number_decimal">
    </pep-icon>
</mat-icon>
<button *ngIf="type === 'phone'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()"
    [disabled]="value.length === 0" [ngClass]="{ disabled: value.length === 0 }">
    <mat-icon>
        <pep-icon name="system_phone">
        </pep-icon>
    </mat-icon>
</button>
<button *ngIf="type === 'email'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()"
    [disabled]="value.length === 0" [ngClass]="{ disabled: value.length === 0 }">
    <mat-icon>
        <pep-icon name="system_email">
        </pep-icon>
    </mat-icon>
</button>
<button *ngIf="type === 'link'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()"
    [disabled]="value.length === 0" [ngClass]="{ disabled: value.length === 0 }">
    <mat-icon>
        <pep-icon name="system_link">
        </pep-icon>
    </mat-icon>
</button>
<button *ngIf="type === 'textarea'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()">
    <mat-icon>
        <pep-icon name="system_full_screen">
        </pep-icon>
    </mat-icon>
</button>
<button *ngIf="type === 'richhtmltextarea'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()">
    <mat-icon>
        <pep-icon name="{{ disabled ? 'system_full_screen' : 'system_edit'}}">
        </pep-icon>
    </mat-icon>
</button>

<button *ngIf="!disabled && type === 'datetime'" class="pepperi-button md regular" mat-button
    (click)="iconButtonClicked()">
    <mat-icon>
        <pep-icon name="time_datetime">
        </pep-icon>
    </mat-icon>
</button>

<button *ngIf="!disabled && type === 'date'" class="pepperi-button md regular" mat-button (click)="iconButtonClicked()">
    <mat-icon>
        <pep-icon name="time_cal">
        </pep-icon>
    </mat-icon>
</button>

<!-- <span class="text-icon" *ngIf="type === 'percentage'">%</span> -->
<!-- <mat-icon matSuffix>sentiment_very_satisfied</mat-icon> -->
<!-- <mat-icon matPrefix>sentiment_very_satisfied</mat-icon> -->
<!-- <mat-hint>Hint</mat-hint> -->
